import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  FaUsers,
  FaQuestionCircle,
  FaFileInvoice,
  FaTruck,
  FaUndo,
  FaUserTie,
  FaUniversity,
  FaChartBar,
  FaBalanceScale,
  FaSignOutAlt,
  FaAngleDown,
  FaAngleUp,
  FaFileInvoiceDollar,
  FaMoneyCheckAlt,
  FaCog,
  FaExchangeAlt,
  FaLayerGroup,
  FaWhatsapp,
  FaTasks,
  FaFolderOpen,
  FaCalendarAlt,
} from "react-icons/fa";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState("whatsapp");

  const handleLogout = () => {
    localStorage.clear();
    navigate("/auth/login");
  };

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  const sections = [
    {
      key: "tasks",
      label: "Task Manager",
      icon: <FaTasks style={{ color: "#0284c7" }} />,
      links: [
        { to: "/dashboard/tasks", label: "Task Board & List" },
      ],
    },
    {
      key: "calendar",
      label: "Calendar",
      icon: <FaCalendarAlt style={{ color: "#2563eb" }} />,
      links: [
        { to: "/dashboard/calendar", label: "Calendar Schedule" },
        { to: "/dashboard/calendar?view=agenda", label: "Upcoming Agenda" },
        { to: "/dashboard/calendar?view=reminders", label: "Reminders & Alerts" },
      ],
    },
    {
      key: "whatsapp",
      label: "WhatsApp Chat",
      icon: <FaWhatsapp style={{ color: "#25d366" }} />,
      links: [
        { to: "/dashboard/whatsapp", label: "WhatsApp Inbox" },
      ],
    },
    {
      key: "customers",
      label: "Customers",
      icon: <FaUsers />,
      links: [
        { to: "/dashboard/customers/new", label: "Add Customer" },
        { to: "/dashboard/customers/list", label: "View Customers" },
      ],
    },
    {
      key: "inquiries",
      label: "Inquiries",
      icon: <FaQuestionCircle />,
      links: [
        { to: "/dashboard/inquiries/new", label: "Add Inquiry" },
        { to: "/dashboard/inquiries/list", label: "View Inquiries" },
      ],
    },
    {
      key: "quotations",
      label: "Quotations",
      icon: <FaFileInvoice />,
      links: [
        { to: "/dashboard/quotations/new", label: "Add Quotation" },
        { to: "/dashboard/quotations/list", label: "View Quotations" },
      ],
    },
    {
      key: "suppliers",
      label: "Suppliers",
      icon: <FaTruck />,
      links: [
        { to: "/dashboard/suppliers/new", label: "Add Supplier" },
        { to: "/dashboard/suppliers/list", label: "View Suppliers" },
      ],
    },
    {
      key: "bulk-sales",
      label: "Bulk Sales",
      icon: <FaLayerGroup />,
      links: [
        { to: "/dashboard/bulk-sales/new", label: "New Bulk Sale" },
        { to: "/dashboard/bulk-sales/list", label: "View Bulk Sales" },
      ],
    },
    {
      key: "receipts",
      label: "Receipts",
      icon: <FaMoneyCheckAlt />,
      links: [
        { to: "/dashboard/receipts/new", label: "Add Receipt" },
        { to: "/dashboard/receipts/list", label: "View All Receipts" },
        { to: "/dashboard/receipts/list?type=Customer", label: "Customer Receipts" },
        { to: "/dashboard/receipts/list?type=Supplier", label: "Supplier Receipts" },
      ],
    },
    {
      key: "payments",
      label: "Payments",
      icon: <FaMoneyCheckAlt />,
      links: [
        { to: "/dashboard/payments/new", label: "Add Payment" },
        { to: "/dashboard/payments/list", label: "View All Payments" },
        { to: "/dashboard/payments/list?type=Customer", label: "Customer Payments" },
        { to: "/dashboard/payments/list?type=Supplier", label: "Supplier Payments" },
      ],
    },
    {
      key: "transactions",
      label: "Transactions",
      icon: <FaFileInvoiceDollar />,
      links: [
        { to: "/dashboard/transactions/purchase-bills/new", label: "Add Purchase Bill" },
        { to: "/dashboard/transactions/purchase-bills/list", label: "View Purchase Bills" },
        { to: "/dashboard/transactions/journal/new", label: "Add Journal Entry" },
        { to: "/dashboard/transactions/journal/list", label: "View Journals" },
      ],
    },
    {
      key: "refunds",
      label: "Refunds",
      icon: <FaUndo />,
      links: [
        { to: "/dashboard/refund/new", label: "Add Refund" },
        { to: "/dashboard/refund/list", label: "View Refunds" },
      ],
    },
    {
      key: "employees",
      label: "Employees",
      icon: <FaUserTie />,
      links: [
        { to: "/dashboard/employees/new", label: "Add Employee" },
        { to: "/dashboard/employees/list", label: "Employee List" },
      ],
    },
    {
      key: "documents",
      label: "Documents",
      icon: <FaFolderOpen style={{ color: "#7c3aed" }} />,
      links: [
        { to: "/dashboard/documents/list", label: "All Documents" },
        { to: "/dashboard/documents/upload", label: "Upload Document" },
        { to: "/dashboard/documents/expiry-alerts", label: "Expiry Alerts" },
      ],
    },
    {
      key: "banks",
      label: "Accounts",
      icon: <FaUniversity />,
      links: [
        { to: "/dashboard/banks/new", label: "Add Banks" },
        { to: "/dashboard/banks/list", label: "View Banks" },
        { to: "/dashboard/coa/list", label: "Chart of Accounts" },
        { to: "/dashboard/credit-notes/list", label: "Credit Notes" },
        { to: "/dashboard/debit-notes/list", label: "Debit Notes" },
        { to: "/dashboard/accounts/bank-reconciliation", label: "Bank Reconciliation" },
        { to: "/dashboard/accounts/cheque-manager", label: "Cheque Manager" },
      ],
    },
    {
      key: "tax",
      label: "Corporate Tax",
      icon: <FaBalanceScale />,
      links: [
        { to: "/dashboard/tax/settings", label: "Tax Settings" },
        { to: "/dashboard/tax/report", label: "Tax Report" },
      ],
    },
    {
      key: "reports",
      label: "Reports",
      icon: <FaChartBar />,
      links: [
        { to: "/dashboard/reports/business-overview", label: "Business Overview" },
        { to: "/dashboard/reports/ledger", label: "Ledger Report" },
        { to: "/dashboard/reports/trial-balance", label: "Trial Balance" },
        { to: "/dashboard/reports/trial-balance-comparison", label: "Trial Balance Comparison" },
        { to: "/dashboard/reports/pnl", label: "Profit & Loss" },
        { to: "/dashboard/reports/pnl-comparison", label: "P&L Comparison" },
        { to: "/dashboard/reports/balance-sheet", label: "Balance Sheet" },
        { to: "/dashboard/reports/balance-sheet-comparison", label: "Balance Sheet Comparison" },
        { to: "/dashboard/reports/cash-flow", label: "Cash Flow" },
        { to: "/dashboard/reports/vat", label: "VAT Report" },
        { to: "/dashboard/reports/outstanding", label: "Outstanding Report" },
        { to: "/dashboard/reports/expense", label: "Expense Report" },
        { to: "/dashboard/reports/pdc-payments", label: "PDC Payments" },
        { to: "/dashboard/reports/aging", label: "Aging Report" },
        { to: "/dashboard/reports/misc", label: "Miscellaneous Report" },
        { to: "/dashboard/reports/service-report", label: "Service Report" },
        { to: "/dashboard/reports/bsp-register", label: "BSP Register Ticket" },
        { to: "/dashboard/reports/sales-purchase", label: "Sales & Purchase Summary" },
      ],
    },
    {
      key: "others",
      label: "Others",
      icon: <FaExchangeAlt />,
      links: [
        { to: "/dashboard/others/pnl-transfer", label: "P&L Transfer" },
        { to: "/dashboard/others/pos-settlement", label: "POS Settlement" },
        { to: "/dashboard/others/cheque-returns", label: "Cheque Returns" },
      ],
    },
    {
      key: "settings",
      label: "Settings",
      icon: <FaCog />,
      links: [
        { to: "/dashboard/settings/company-profile", label: "Company Profile" },
        { to: "/dashboard/settings/permissions", label: "Module Permissions" },
        { to: "/dashboard/templates", label: "Document Templates" },
      ],
    },
  ];

  return (
    <div
      style={{
        width: "260px",
        height: "100vh",
        maxHeight: "100vh",
        background: "#f4fbff",
        borderRight: "1px solid #e0f0ff",
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
        overflow: "hidden",
      }}
    >
      <style>{`
        .custom-sidebar-scroll::-webkit-scrollbar {
          width: 6px;
        }
        .custom-sidebar-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-sidebar-scroll::-webkit-scrollbar-thumb {
          background: rgba(0, 170, 255, 0.25);
          border-radius: 4px;
        }
        .custom-sidebar-scroll::-webkit-scrollbar-thumb:hover {
          background: rgba(0, 170, 255, 0.5);
        }
        .custom-sidebar-scroll {
          scrollbar-width: thin;
          scrollbar-color: rgba(0, 170, 255, 0.25) transparent;
        }
      `}</style>

      {/* Logo */}
      <div
        style={{
          padding: "20px 18px",
          fontWeight: "bold",
          fontSize: "20px",
          color: "#0077cc",
          borderBottom: "1px solid #e0f0ff",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <img
          src={process.env.PUBLIC_URL + "/rekonic-logo.jpg"}
          alt="Rekonic Logo"
          style={{ 
            maxWidth: "200px", 
            height: "85px", 
            objectFit: "contain",
            mixBlendMode: "multiply"
          }}
        />
      </div>

      {/* Menu */}
      <ul
        className="list-unstyled custom-sidebar-scroll"
        style={{
          padding: "10px",
          margin: 0,
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {sections.map((section) => (
          <li key={section.key}>
            {/* Section */}
            <div
              onClick={() => toggleDropdown(section.key)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 12px",
                borderRadius: "8px",
                cursor: "pointer",
                background:
                  openDropdown === section.key
                    ? "rgba(0,170,255,0.1)"
                    : "transparent",
                color:
                  openDropdown === section.key ? "#0077cc" : "#333",
                fontWeight: "500",
              }}
            >
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <span style={{ color: "#00aaff" }}>{section.icon}</span>
                {section.label}
              </div>

              {openDropdown === section.key ? <FaAngleUp /> : <FaAngleDown />}
            </div>

            {/* Links */}
            {openDropdown === section.key && (
              <div style={{ marginLeft: "30px", marginTop: "5px" }}>
                {section.links.map((link) => {
                  const active = location.pathname === link.to;
                  return (
                    <Link
                      key={link.to}
                      to={link.to}
                      style={{
                        display: "block",
                        padding: "6px 10px",
                        borderRadius: "6px",
                        textDecoration: "none",
                        fontSize: "14px",
                        color: active ? "#0077cc" : "#555",
                        background: active
                          ? "rgba(0,170,255,0.15)"
                          : "transparent",
                        fontWeight: active ? "600" : "400",
                      }}
                    >
                      {link.label}
                    </Link>
                  );
                })}
              </div>
            )}
          </li>
        ))}
      </ul>

      {/* Logout */}
      <div
        style={{
          marginTop: "auto",
          padding: "15px",
          borderTop: "1px solid #e0f0ff",
          background: "#f4fbff",
          flexShrink: 0,
        }}
      >
        <button
          onClick={handleLogout}
          style={{
            width: "100%",
            background: "#00aaff",
            border: "none",
            padding: "10px",
            color: "#fff",
            borderRadius: "8px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          <FaSignOutAlt /> Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
